// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"16a2d21d","119":"5a2f5287","453":"a04ae9d0"}[chunkId] + ".chunk.js";
};